import { http, HttpResponse } from 'msw';
import type { ChangeLogEntry, Building } from './types';

// ─── Mock data (from Figma) ──────────────────────────────────────────────────

export const MOCK_BUILDING: Building = {
  id: 'BFR15720257',
  name: 'Groupe Scolaire Biroubou',
  address: '2 rue des Saules Plongeurs',
  city: 'Brétigny-sur-Orge',
  postalCode: '91220',
  identification: {
    urbanMapId: 'BFR 15720257',
    rnbIds: ['9986382', '9986382'],
    bdndId: '12578612 – 12578612',
    ignId: 'XXXXX',
    parcelleId: 'XXXXX',
    installationGenesis: ['556322', '556322'],
    idPlaceImmobilier: '9986382',
    idExplore: '9986382',
  },
  totalArea: 2363,
  storeys: 3,
  constructionYear: 1967,
  renovationYear: 2003,
  dpe: 'A',
  purpose: 'Commerce',
  secondaryPurpose: 'Habitat collectif',
  heatingType: 'Gas',
  hotWaterType: 'Gas',
  publicPrivate: 'Private',
  heatConsumption: 840000,
  coldConsumption: 0,
};

export const MOCK_CHANGE_LOG: ChangeLogEntry[] = [
  {
    id: '1',
    attribute: 'Usage principal',
    newValue: 'Commerce',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: 'Habitat collectif',
    oldValueStatus: 'conflict',
    dateTime: '18/06/2026 - 13:12',
    type: 'Manuel',
  },
  {
    id: '2',
    attribute: 'Surface usage principal, en % de la surface totale',
    newValue: '65',
    newValueStatus: 'validated',
    author: 'Anita Rumery',
    oldValue: '55',
    oldValueStatus: 'conflict',
    dateTime: '18/06/2026 - 13:10',
    type: 'Manuel',
  },
  {
    id: '3',
    attribute: 'Usage secondaire',
    newValue: 'Habitat collectif',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: 'Commerce',
    oldValueStatus: 'neutral',
    dateTime: '13/06/2026 - 18:06',
    type: 'Import',
  },
  {
    id: '4',
    attribute: 'Surface usage secondaire (m²), % de la surface totale',
    newValue: '35',
    newValueStatus: 'validated',
    author: 'Anita Rumery',
    oldValue: '45',
    oldValueStatus: 'neutral',
    dateTime: '13/06/2026 - 12:09',
    type: 'Import',
  },
  {
    id: '5',
    attribute: 'DPE',
    newValue: 'A',
    newValueStatus: 'validated',
    author: 'Anita Rumery',
    oldValue: 'B',
    oldValueStatus: 'neutral',
    dateTime: '13/06/2026 - 12:09',
    type: 'Import',
  },
  {
    id: '6',
    attribute: 'Année de construction',
    newValue: '1967',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: '1966',
    oldValueStatus: 'conflict',
    dateTime: '11/05/2026 - 14:56',
    type: 'Manuel',
  },
  {
    id: '7',
    attribute: 'Année de rénovation',
    newValue: '2003',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: '2007',
    oldValueStatus: 'conflict',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
  {
    id: '8',
    attribute: 'Surface totale',
    newValue: '30 225 m²',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: '29 675 m²',
    oldValueStatus: 'conflict',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
  {
    id: '9',
    attribute: 'Nb de niveaux',
    newValue: '6',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: '5',
    oldValueStatus: 'conflict',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
  {
    id: '10',
    attribute: 'Nb de logements',
    newValue: '20',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: '24',
    oldValueStatus: 'conflict',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
  {
    id: '11',
    attribute: 'Type de propriétaire',
    newValue: 'Privé',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: 'Public',
    oldValueStatus: 'conflict',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
  {
    id: '12',
    attribute: 'Identité propriétaire',
    newValue: 'Foncia, CAAP IMMO INVEST, COMMUNAUTE DE COMMUNES DU PAYS DE NEMOURS, IENA, BPCE LEASE IMMO',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: 'CAAP IMMO INVEST',
    oldValueStatus: 'neutral',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
  {
    id: '13',
    attribute: 'SIREN propriétaire',
    newValue: '800887879',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: '-',
    oldValueStatus: 'neutral',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
  {
    id: '14',
    attribute: 'N° de copropriété',
    newValue: '-',
    newValueStatus: 'neutral',
    author: 'Martin Maurey',
    oldValue: 'AF4929592',
    oldValueStatus: 'conflict',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
  {
    id: '15',
    attribute: 'Syndic gestionnaire / Property manager',
    newValue: '800887879',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: '-',
    oldValueStatus: 'neutral',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
  {
    id: '16',
    attribute: 'SIREN syndic',
    newValue: '800670965',
    newValueStatus: 'validated',
    author: 'Martin Maurey',
    oldValue: '800887879',
    oldValueStatus: 'conflict',
    dateTime: '06/03/2026 - 13:45',
    type: 'Manuel',
  },
];

// ─── MSW handlers ────────────────────────────────────────────────────────────

export const handlers = [
  http.get('/api/urban-map/buildings/:id/change-log', () => {
    return HttpResponse.json(MOCK_CHANGE_LOG);
  }),
  http.get('/api/urban-map/buildings/:id', () => {
    return HttpResponse.json(MOCK_BUILDING);
  }),
];
